import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SupplyAccountType} from "../../../account/types/supply-account.type";
import {AccountModel} from "../../../account/angular/models/account.model";

export class AccountCommissionsViewCtrl implements IController {

  account: AccountModel;
  showConsolidated: boolean;

  private currentNavItem: any;
  public supplyAccountTypes: typeof SupplyAccountType = SupplyAccountType;

  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = _.last(_.split(this.$state.current.name, '.'));
  };
}

angular
  .module('bringoz.admin.commissions')
  .component('accountCommissionsView', {
    bindings: {
      account: '<',
      showConsolidated: '<'
    },
    template: require('./account-commissions-view.html').default,
    controller: AccountCommissionsViewCtrl
  });
